import { Text, View } from '@react-pdf/renderer'
import PDFCell from '@/components/ReportPDF/PDFCell'
import PDFPage from '@/components/ReportPDF/PDFPage'
import PDFRow from '@/components/ReportPDF/PDFRow'
import PDFTitle from '@/components/ReportPDF/PDFTitle'
import PDFParagraph from '@/components/ReportPDF/PDFParagraph'

const Header = ({ title }) => (
  <PDFCell flex={2} style={{ padding: 0, alignItems: 'stretch' }}>
    <PDFCell
      style={{
        backgroundColor: `#4c82bf`,
        border: 'none',
      }}
    >
      <Text style={{ color: 'white' }}>{title}</Text>
    </PDFCell>
    <PDFRow style={{ margin: -0.5 }}>
      <PDFCell flex={1} style={{ backgroundColor: '#d7e0ed' }}>
        <Text>人數</Text>
      </PDFCell>
      <PDFCell flex={1} style={{ backgroundColor: '#d7e0ed' }}>
        <Text>比率</Text>
      </PDFCell>
    </PDFRow>
  </PDFCell>
)

const ReportRow = ({ reportData = {} }) => {
  const { year, report = {} } = reportData
  const {
    userCount,
    openCount,
    openPercent,
    linkCount,
    linkPercent,
    fileCount,
    filePercent,
    textCount,
    textPercent,
  } = report

  const formatPercent = value => {
    if (value != null) {
      return Number(value).toFixed(2) // 強制保留兩位小數
    }
    return '0.00' // 無效值回傳 '0.00'
  }

  const formattedReport = {
    userCount,
    openCount,
    openPercent: formatPercent(openPercent),
    linkCount,
    linkPercent: formatPercent(linkPercent),
    fileCount,
    filePercent: formatPercent(filePercent),
    textCount,
    textPercent: formatPercent(textPercent),
  }

  // 解析日期
  const date = new Date(year)

  // 取得年份和月份，並格式化為 YYYY/MM
  const formattedDate = `${date.getFullYear()}/${(date.getMonth() + 1).toString().padStart(2, '0')}`

  return (
    <PDFRow width={1075} marginLeft={-85}>
      <PDFCell flex={1} style={{ backgroundColor: '#e8ecf2' }}>
        <Text>{formattedDate}</Text>
      </PDFCell>

      <PDFCell flex={1} style={{ backgroundColor: '#e8ecf2' }}>
        <Text>{userCount || 0}</Text>
      </PDFCell>

      <PDFCell flex={2} style={{ alignItems: 'stretch', padding: 0, backgroundColor: '#e8ecf2' }}>
        <PDFRow style={{ margin: -0.5 }}>
          <PDFCell flex={1}>
            <Text>{openCount || 0}</Text>
          </PDFCell>
          <PDFCell flex={1}>
            <Text>{formattedReport.openPercent || 0}%</Text>
          </PDFCell>
        </PDFRow>
      </PDFCell>

      <PDFCell flex={2} style={{ alignItems: 'stretch', padding: 0, backgroundColor: '#e8ecf2' }}>
        <PDFRow style={{ margin: -0.5 }}>
          <PDFCell flex={1}>
            <Text>{linkCount || 0}</Text>
          </PDFCell>
          <PDFCell flex={1}>
            <Text>{formattedReport.linkPercent || 0}%</Text>
          </PDFCell>
        </PDFRow>
      </PDFCell>

      <PDFCell flex={2} style={{ alignItems: 'stretch', padding: 0, backgroundColor: '#e8ecf2' }}>
        <PDFRow style={{ margin: -0.5 }}>
          <PDFCell flex={1}>
            <Text>{fileCount || 0}</Text>
          </PDFCell>
          <PDFCell flex={1}>
            <Text>{formattedReport.filePercent || 0}%</Text>
          </PDFCell>
        </PDFRow>
      </PDFCell>

      <PDFCell flex={2} style={{ alignItems: 'stretch', padding: 0, backgroundColor: '#e8ecf2' }}>
        <PDFRow style={{ margin: -0.5 }}>
          <PDFCell flex={1}>
            <Text>{textCount || 0}</Text>
          </PDFCell>
          <PDFCell flex={1}>
            <Text>{formattedReport.textPercent || 0}%</Text>
          </PDFCell>
        </PDFRow>
      </PDFCell>
    </PDFRow>
  )
}

const Chapter4Sub8Page = ({ reportData, setPage }) => {
  const { reprotHistories } = reportData || {}

  return (
    <PDFPage hideTitleDivider reportData={reportData}>
      {/* {shouldRenderOfficePage ? (
        <PDFTitle hideDivider>4.7 歷年演練結果比較</PDFTitle>
      ) : (
        <PDFTitle hideDivider>4.6 歷年演練結果比較</PDFTitle>
      )}
      {shouldRenderOfficePage ? (
        <Text
          render={({ pageNumber }) => {
            setPage({ chap4_7: pageNumber })
          }}
        />
      ) : (
        <Text
          render={({ pageNumber }) => {
            setPage({ chap4_6: pageNumber })
          }}
        />
      )} */}

      <PDFTitle hideDivider>4.5 歷年演練結果</PDFTitle>

      <Text
        render={({ pageNumber }) => {
          setPage({ chap4_5: pageNumber })
        }}
      />

      <View>
        <PDFParagraph>
          {'    '}
          依據歷史演練結果分析，列出近五次演練結果數據，根據不同演練項目的檢測狀態，蒐集並統計近五次演練的整體成果，呈現不同時期演練結果之圖表。
        </PDFParagraph>

        <PDFParagraph>
          {'    '}依照
          <Text style={{ fontWeight: 'bold', fontSize: 20 }}>歷年受測人數</Text>
          <Text>統計之「瀏覽郵件」、「點閱連結」、「開啟附件」與「輸入資料」演練統計報表：</Text>
        </PDFParagraph>

        <PDFRow style={{ fontWeight: 'bold' }} width={1075} marginLeft={-85}>
          <PDFCell
            flex={1}
            style={{
              backgroundColor: `#4c82bf`,
            }}
          >
            <Text style={{ color: 'white' }}>年度</Text>
          </PDFCell>
          <PDFCell
            flex={1}
            style={{
              backgroundColor: `#4c82bf`,
            }}
          >
            <Text style={{ color: 'white' }}>受測人數</Text>
          </PDFCell>
          <Header title={'瀏覽信件'} />

          <Header title={'點閱連結'} />

          <Header title={'開啟附件'} />

          <Header title={'輸入資料'} />
        </PDFRow>

        {reprotHistories?.map((report, index) => (
          <ReportRow key={`${index + 1}`} reportData={report} />
        ))}
      </View>
    </PDFPage>
  )
}

export default Chapter4Sub8Page
